export const MANAGER_DASHBOARD_PENDING = "MANAGER_DASHBOARD_PENDING";
export const MANAGER_DASHBOARD_FULFILLED = "MANAGER_DASHBOARD_FULFILLED";
export const MANAGER_DASHBOARD_REJECTED = "MANAGER_DASHBOARD_REJECTED";
export const TEAM_OVERVIEW_PENDING = "TEAM_OVERVIEW_PENDING";
export const TEAM_OVERVIEW_FULFILLED = "TEAM_OVERVIEW_FULFILLED";
export const TEAM_OVERVIEW_REJECTED = "TEAM_OVERVIEW_REJECTED";
